import { Button } from '@cian/ui-kit';
import { LinkButton } from '@cian/ui-kit/button';
import { IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

type TMobileAddOfferButtonProps = {
  type: 'mobile';
  onClick(): void;
};

type TDesktopAddOfferButtonProps = {
  type: 'desktop';
  href: string;
  onClick(): void;
  shouldShowNewPlacementText: boolean;
};

export type TAddOfferButtonProps = TMobileAddOfferButtonProps | TDesktopAddOfferButtonProps;

export function AddOfferButton(props: TAddOfferButtonProps) {
  if (props.type === 'desktop') {
    return (
      <LinkButton href={props.href} size="XS" onClick={props.onClick} data-testid="header-add-offer-buttons">
        + {props.shouldShowNewPlacementText ? 'Разместить за 0 ₽' : 'Разместить объявление'}
      </LinkButton>
    );
  }

  return (
    <Button
      beforeIcon={<IconActionPlus16 color="icon-main-default" />}
      onClick={props.onClick}
      size="XS"
      fullWidth
      theme="fill_secondary"
      data-testid="header-add-offer-buttons"
    >
      Разместить
    </Button>
  );
}
